import { render, staticRenderFns } from "./addBulkEvent.vue?vue&type=template&id=1f1cba13&scoped=true&"
import script from "./addBulkEvent.vue?vue&type=script&lang=js&"
export * from "./addBulkEvent.vue?vue&type=script&lang=js&"
import style0 from "./addBulkEvent.vue?vue&type=style&index=0&id=1f1cba13&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f1cba13",
  null
  
)

export default component.exports